<template>
    <ul class="list__ul">
        <!--standard-->
        <template v-if="type === TYPE_STANDARD">
            <li>
                <b>Moteur :</b>
                <div>
                    Pièces lubrifiées mobiles et internes (attelage mobile, cylindres ou chemises, chaînes et pignons de
                    distribution, pompe à huile, roulement de bielle, culasses et joints de culasse) ainsi que tous les
                    dommages mécaniques portant sur le bloc moteur et résultant directement de l’avarie. Le remplacement
                    de la chaîne de distribution et les avaries résultant de sa dégradation ne seront pris en charge que
                    si son taux d’usure n’est pas supérieur à celui toléré par le constructeur.
                </div>
            </li>
            <li>
                <b>Boîte de vitesse :</b>

                <div>
                    Toutes les pièces internes du bloc, soit :
                </div>

                <div>
                    <i>- pour la boite mécanique : </i>pièces lubrifiées mobiles et internes de la boîte (pignons,
                    arbres,
                    paliers, roulements, synchros, circlips, fourchettes de commande) ainsi que tous les dommages
                    mécaniques portant sur le carter et qui résultent directement de l’avarie.
                </div>
                <div>
                    <i>- pour la Transmission automatique : </i>Variateurs et réducteurs (joints et courroies de
                    transmission exclus).
                </div>
            </li>
        </template>

        <!--complete-->
        <template v-if="type === TYPE_COMPLETE">
            <li>
                <b>Moteur : </b>
                <div>
                    Pièces lubrifiées mobiles et internes (attelage mobile, cylindres ou chemises, chaînes et pignons de
                    distribution, pompe à huile, roulement de bielle, culasses et joints de culasse) ainsi que tous les
                    dommages mécaniques portant sur le bloc moteur et résultant directement de l’avarie. Le remplacement
                    de la chaîne de distribution et les avaries résultant de sa dégradation ne seront pris en charge que
                    si son taux d’usure n’est pas supérieur à celui toléré par le constructeur.
                </div>
            </li>
            <li>
                <b>Boîte de vitesse : </b>
                <div>
                    Toutes les pièces internes du bloc, soit :
                </div>

                <div>
                    - pour la boite mécanique : pièces lubrifiées mobiles et internes de la boîte (pignons, arbres,
                    paliers, roulements, synchros, circlips, fourchettes de commande) ainsi que tous les dommages
                    mécaniques portant sur le carter et qui résultent directement de l’avarie.
                </div>
                <div>
                    - pour la Transmission automatique : Variateurs et réducteurs (joints et courroies de transmission
                    exclus)
                </div>
            </li>
            <li>
                <b>Transmission secondaire à cardan : </b>
                <div>
                    Couple conique (sauf joints spy), roulements, arbre de transmission (sauf soufflet de cardan).
                </div>
            </li>
            <li>
                <b>Embrayage : </b>
                <div>
                    Emetteur, récepteur hydraulique.
                </div>
            </li>
            <li>
                <b>Circuit d’alimentation de série : </b>
                <div>
                    Carburateur, pompes d’alimentation, injecteurs.
                </div>
            </li>
            <li>
                <b>Circuit électrique et électronique de série : </b>
                <div>
                    Alternateur, démarreur et modules électroniques de gestion d’allumage et d’alimentation moteur.
                </div>
            </li>
            <li>
                <b>Circuit de refroidissement : </b>
                <div>
                    Pompe à eau, radiateurs (eau et/ou huile), moto-ventilateurs, calorstat.
                </div>
            </li>
            <li>
                <b>Freins : </b>
                <div>
                    Maître-cylindre, calculateur et capteur antiblocage des roues, émetteur, étriers, servofrein.
                </div>
            </li>
            <li>
                <b>Suspension : </b>
                <div>
                    Axes de pivots et bagues, ressorts, rotules, roulements de roues, roulements de bras oscillant et de
                    fourches. Les amortisseurs sont exclus.
                </div>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        name: 'GarantiesAccordesMoto',
        props: {
            insurance: Object,
        },
        data() {
            return {
                TYPE_STANDARD: 1,
                TYPE_COMPLETE: 2,
            }
        },
        computed: {
            type() {
                if (!this.insurance || !this.insurance.details) return 0;
                return +this.insurance.details.garantie;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Garantie/GarantiesAccordesMoto.vue